import type { ReactNode } from "react";
import styles from "./page-wrapper.module.scss";

export function PageWrapper({ children }: { children: ReactNode }) {
  return (
    <main className={styles.pageWrapper} data-testid="page-wrapper">
      {children}
    </main>
  );
}
